<div class="subscription-management-container">
    <div class="title">
        Subscribed Students List
    </div>
    <div class="filter">
        <div class="category" (click)="onChangeEnrollFilter('All')" [ngClass]="{ active: enrollFilter === 'All' }">
            All Students
        </div>
        <div class="category" (click)="onChangeEnrollFilter('Pending')"
            [ngClass]="{ active: enrollFilter === 'Pending' }">
            Pending Approvals
        </div>
        <div class="category" (click)="onChangeEnrollFilter('Approved')"
            [ngClass]="{ active: enrollFilter === 'Approved' }">
            Approved Students
        </div>
        <div class="category" (click)="onChangeEnrollFilter('Rejected')"
            [ngClass]="{ active: enrollFilter === 'Rejected' }">
            Rejected Students
        </div>
        <div class="category" (click)="onChangeEnrollFilter('Expired')"
            [ngClass]="{ active: enrollFilter === 'Expired' }">
            Expired Students
        </div>
    </div>
    <div class="student-list">
        <table class="table">
            <tr class="table-header">
                <th [style]="{ width: '10%' }"></th>
                <th [style]="{ width: '40%' }">Student Name</th>
                <th [style]="{ width: '40%' }">Subscription Status</th>
                <th [style]="{ width: '10%' }">Menu</th>
            </tr>
            <tr class="table-body" *ngIf="!subscribedUsers[enrollFilter]">
                <td [style]="{width: '100%'}">
                    No Record Found!
                </td>
            </tr>
            <tr class="table-body" *ngFor="let user of subscribedUsers[enrollFilter]; let i = index">
                <td [style]="{ width: '10%' }" class="user-icon">
                    <div class="icon">
                        <i class="fa-solid fa-user"></i>
                    </div>
                </td>
                <td [style]="{ width: '40%' }">
                    {{ user.firstName }} {{ user.lastName }}
                </td>
                <td [style]="{ width: '40%' }">
                    {{ user.subscription.subscriptionStatus }}
                </td>
                <td [style]="{ width: '10%' }">
                    <div class="menu">
                        <div class="menu-icon">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        <div class="menu-items">
                            <div class="menu-item" *ngIf="
                                user.subscription.subscriptionStatus === 'Pending' || user.subscription.subscriptionStatus === 'Approved'
                      " (click)="restrict(user)">
                                Restrict access
                            </div>
                            <div class="menu-item" *ngIf="
                                user.subscription.subscriptionStatus === 'Pending' || user.subscription.subscriptionStatus === 'Rejected'
                      " (click)="enable(user)">
                                Enable access
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>